/**
 * The AFF permission keys (#795, #813, #866), shared by the backend gates and
 * the UI. What each operation covers is described in migration 044.
 */
export const AFF_FEATURE = 'aff';
export const AFF_READ_OP = 'read';
export const AFF_EXPLORE_OP = 'explore';
export const AFF_EXPORT_OP = 'export';
export const AFF_SIMULATE_OP = 'simulate';

/** The CSV export entities and GIS Download layers that carry AFF data, so need aff.export. */
export const AFF_EXPORT_IDS: readonly string[] = ['aff_aircraft', 'aff_tracks'];
